// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yhg33","data":"styles_data__L3C--","spin":"styles_spin__nG0gG"};